var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "gh-sidebar__body gh-sidebar__body--detail" },
    [
      _vm.downloadLoading
        ? _c("div", { staticClass: "gh-sidebar__download-loading" }, [
            _c("i", {
              staticClass: "fa fa-spinner fa-spin",
              attrs: { "aria-hidden": "true" },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.listLoading && !_vm.listItems.length
        ? _c("div", { staticClass: "gh-sidebar__loading" }, [
            _c("i", {
              staticClass: "fa fa-spinner fa-spin",
              attrs: { "aria-hidden": "true" },
            }),
          ])
        : _vm.listError
        ? _c("div", { staticClass: "gh-sidebar__error" }, [
            _vm._v(_vm._s(_vm.listError)),
          ])
        : !_vm.listItems.length
        ? _c("div", { staticClass: "gh-sidebar__empty" }, [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("generation_history.sZeroRecords")) +
                "\n  "
            ),
          ])
        : _c(
            "transition-group",
            {
              ref: "listEl",
              staticClass: "gh-sidebar__cards gh-sidebar__list",
              attrs: { name: "gh-favorite-card", tag: "div" },
              nativeOn: {
                scroll: function ($event) {
                  return _vm.onListScroll.apply(null, arguments)
                },
              },
            },
            _vm._l(_vm.displayCards, function (card, cardIndex) {
              return _c(
                "div",
                {
                  key: _vm.getCardKey(card),
                  staticClass: "gh-favorite-card-item",
                  class: {
                    "gh-favorite-card-item--removing": _vm.isRemoving(card),
                  },
                },
                [
                  _c(
                    _vm.resolveDetailCardComponent(card.project_type),
                    {
                      tag: "component",
                      attrs: {
                        card: card,
                        "project-type": card.project_type,
                        collapsed: _vm.isCardCollapsed(cardIndex),
                        "is-copied": _vm.isCopySuccess(card, "text"),
                        "is-image-copied": _vm.isCopySuccess(card, "image"),
                        "is-prompt-copied": _vm.isCopySuccess(card, "prompt"),
                      },
                      on: {
                        "toggle-collapse": function ($event) {
                          return _vm.toggleCard(cardIndex)
                        },
                        copy: function ($event) {
                          return _vm.onCopyText(card)
                        },
                        "copy-image": function ($event) {
                          return _vm.onCopyImage(card, $event)
                        },
                        "copy-prompt": function ($event) {
                          return _vm.onCopyPrompt(card)
                        },
                        download: function ($event) {
                          return _vm.onDownload(card)
                        },
                        favorite: function ($event) {
                          return _vm.onToggleFavorite(card)
                        },
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "context-head" },
                        [
                          _c("GenerationHistoryListItemHead", {
                            attrs: {
                              "service-name-key": _vm.getServiceNameKey(
                                card.project_type
                              ),
                              "project-name": card.project_name,
                              datetime: card.request_datetime_ts,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              )
            }),
            0
          ),
      _vm._v(" "),
      _vm.listLoading && _vm.listItems.length
        ? _c("div", { staticClass: "gh-sidebar__loading-more" }, [
            _c("i", {
              staticClass: "fa fa-spinner fa-spin",
              attrs: { "aria-hidden": "true" },
            }),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }